import React from 'react';
import { Text } from 'components/_temp_ui_common/theme/Text';

export default function PhoneLink({
  phone,
  color = '#018847',
  bold = false,
  ...props
}: React.ComponentProps<'a'> & {
  phone: string;
  color?: string;
  bold?: boolean;
}) {
  return (
    <a
      {...props}
      href={`tel:${phone}`}
      className="cursor-pointer hover:underline"
      style={{ color }}
    >
      <Text variant="body-4" bold={bold} style={props.style}>
        {phone}
      </Text>
    </a>
  );
}
